import React from 'react';
import RichTextUndoRedoButton from "./RichTextUndoRedoButton";
import RichTextHeadingDropdownMenu from "./RichTextHeadingDropdownMenu";
import RichTextListDropdownMenu from "./RichTextListDropdownMenu";
import RichTextActionButton from "./RichTextActionButton";
import RichTextAlignButton from "./RichTextAlignButton";
import RichTextLinkButton from "./RichTextLinkButton";
import "../css/style-rich-text.css";

const RichTextToolbar = ({wrapperClass = "", endActions, children}) => {
    return (
        <div className={["rich-text-toolbar print:hidden", wrapperClass].filter(Boolean).join(" ")} role="toolbar">
            {children}

            <div className="toolbar-group">
                <RichTextUndoRedoButton action="undo" disabled={false}/>
                <RichTextUndoRedoButton action="redo" disabled={false}/>
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextHeadingDropdownMenu levels={[1, 2, 3, 4, 5, 6]}/>
                <RichTextListDropdownMenu types={["bulletList", "orderedList"]} />
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextActionButton type="bold" />
                <RichTextActionButton type="italic" />
                <RichTextActionButton type="underline" />
                <RichTextActionButton type="strike" />
                <RichTextLinkButton />
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextAlignButton align="left"/>
                <RichTextAlignButton align="center"/>
                <RichTextAlignButton align="right"/>
                <RichTextAlignButton align="justify"/>
            </div>

            {endActions && (
                <>
                    <div className="rich-text-separator"/>
                    <div className="toolbar-group">{endActions}</div>
                </>
            )}
        </div>
    );
};

export default RichTextToolbar;
